exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title .title-style1[data-v-9f6b6a90] {\n  width: 100%;\n  padding: 13px 0;\n}\n.title .title-style1 .title-content[data-v-9f6b6a90] {\n  font-weight: 500;\n}\n.title .title-style1 .title-content img[data-v-9f6b6a90] {\n  display: block;\n}\n.title .title-style1 .more-content img[data-v-9f6b6a90] {\n  display: block;\n}\n", ""]);

// exports
